import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistGate } from "zustand-persist";
import "./App.css";
import Routing from "./routing";
import { useAuthStore } from "./store/authStore";
import FullPageLoader from "./components/UI/loader/fullPageLoader";
import "./fullCalender.css";

const queryClient = new QueryClient();

function App() {
  // const store = useAuthStore();
  const { loader } = useAuthStore((state) => state)
  return (
    // <PersistGate>
    <QueryClientProvider client={queryClient}>
      {loader && <FullPageLoader />}
      <Routing />
    </QueryClientProvider>
    // </PersistGate>
  );
}

export default App;
